module.exports = __webpack_public_path__ + "imgs/hybrid.7df66499304d33f85bd4a27b0369c5b3.jpg";